import { inject, Injectable, signal } from '@angular/core';
import { LocalStorageService } from '../services/LocalStorageService';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root'
})
export class SeatsPlanStore {

  private readonly _localStorageService = inject(LocalStorageService);

  public readonly isTouchInteractionsEnabled = signal<boolean>(false);
  public readonly rowNameOnLeft = signal<boolean>(false);

  public constructor() {
    const savedValue = this._localStorageService.getItem('seats-plan-touch-interactions-enabled');
    
    if (savedValue !== null) {
      this.isTouchInteractionsEnabled.set(savedValue);
    }

    toObservable(
      this.isTouchInteractionsEnabled
    ).subscribe(isEnabled => {
      this._localStorageService.setItem('seats-plan-touch-interactions-enabled', isEnabled);
    });
  }

  public toggleTouchInteractions(): void {
    this.isTouchInteractionsEnabled.update(value => !value);
  }
}

